const run = func => func ? func() : null

export const runByFeature = (features, options) => {
  if (features) {
    const func = Object.entries(options).find(([key, value]) => features[key] ? value : null);
    return func ? run(func[1]) : run(options['otherwise'])
  }
  return run(options['otherwise'])
}
